import { render } from "./ActiveCallTable.vue?vue&type=template&id=e5be16f0"
import script from "./ActiveCallTable.vue?vue&type=script&lang=js"
export * from "./ActiveCallTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__